// import { Navigate } from "react-router-dom";
//import { Trans } from "react-i18next";
import Course from "../screens/course";
import Academy from "../screens/academy";
import Job from "../screens/job";
import Skill from "../screens/skill";
import VideoPlayer from "../components/player";
import Profile from "../screens/profile";
import MyProgress from "../screens/my-progress";
import Skillpath from "../screens/skillpath";

const ROUTES = [
  {
    path: "/docebo-player/:id",
    component: <VideoPlayer loadIdFromUrl onClose={() => alert("Closed")} />,
    exact: true,
    showInSideMenu: false,
    titleSuffix: "courseScreen.documentTitle",
  },
  {
    path: "/courses/:id",
    component: <Course />,
    exact: true,
    showInSideMenu: false,
    titleSuffix: "courseScreen.documentTitle",
  },
  {
    path: "/academies/:id",
    component: <Academy />,
    exact: true,
    showInSideMenu: false,
    titleSuffix: "academyScreen.documentTitle",
  },
  {
    path: "/skill-paths/:id",
    component: <Skillpath />,
    exact: true,
    showInSideMenu: false,
    titleSuffix: "skillpathScreen.documentTitle",
  },
  {
    path: "/jobs/:id",
    component: <Job />,
    exact: true,
    showInSideMenu: false,
    titleSuffix: "jobScreen.documentTitle",
  },
  {
    path: "/skills/:id",
    component: <Skill />,
    exact: true,
    showInSideMenu: false,
    titleSuffix: "skillGoalScreen.documentTitle",
  },
  {
    path: "/profile",
    component: <Profile />,
    exact: true,
    showInSideMenu: false,
    titleSuffix: "profileScreen.documentTitle",
  },
  {
    path: "/my-progress",
    exact: true,
    showInSideMenu: false,
    titleSuffix: "dashboardScreen.documentTitle",
    redirectTo: "/my-progress/jobs-and-skills/my-skills",
  },
  {
    path: "/my-progress/jobs-and-skills",
    exact: true,
    showInSideMenu: false,
    titleSuffix: "dashboardScreen.documentTitle",
    redirectTo: "/my-progress/jobs-and-skills/my-skills",
  },
  {
    path: "/my-progress/*",
    component: <MyProgress />,
    exact: false,
    showInSideMenu: false,
    titleSuffix: "dashboardScreen.documentTitle",
  },
];

export default ROUTES;
